import styled from 'styled-components';
import { Form, Input } from '@rocketseat/unform';

import { darken } from 'polished';

export const Container = styled.div`
  padding: 0 30px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 50px 0;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: #fff;

  filter: ${props => (props.blur ? 'blur(2px)' : 'none')};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  margin-bottom: 10px;

  div {
    display: flex;
  }
`;

export const GeneralButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 25px;

  padding: 10px 20px;

  font: 400 16px 'Roboto', sans-serif;
  color: #fff;

  transition: all 0.2s;

  & + button {
    margin-left: 10px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.4);
  }
`;

export const DeleteButton = styled(GeneralButton)`
  background: #db5461;
  transition: all 0.3s;

  &:hover {
    transition: all 0.3s;

    background: ${darken(0.075, '#db5461')};
  }
`;

export const ConfirmButton = styled(GeneralButton)`
  background: #59c17c;
  transition: all 0.3s;

  &:hover {
    background: ${darken(0.075, '#59c17c')};
  }
`;

export const QuestionForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

export const QuestionInput = styled(Input)`
  margin: 10px 0;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.2);

  width: 100%;
  height: 150px;
  border: none;
  border-radius: 20px;

  resize: none;

  font: 400 24px 'Roboto', sans-serif;
  color: #fff;

  transition: all 0.2s;

  &::placeholder {
    font: 300 24px 'Roboto', sans-serif;
    color: #fffb;
  }

  &:focus {
    background: rgba(0, 0, 0, 0.4);
  }
`;

export const CommentInput = styled(QuestionInput)`
  font: 400 18px 'Roboto', sans-serif;

  &::placeholder {
    font: 300 16px 'Roboto', sans-serif;
    color: #fffb;
  }
`;

export const AwnserInput = styled(Input)`
  margin: 10px 0;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.2);

  width: 100%;
  height: 40px;

  box-shadow: none;

  border: none;
  border-radius: 20px;

  font: 400 18px 'Roboto', sans-serif;
  color: #fff;

  transition: all 0.3s;

  &::placeholder {
    font: 300 16px 'Roboto', sans-serif;
    color: #fffb;
  }

  &:focus {
    box-shadow: ${props =>
    props.name === 'option_0' // eslint-disable-line
      ? '0 0 10px 2px #59C17C inset'  // eslint-disable-line
      : '0 0 10px 2px #DB5461 inset'  // eslint-disable-line
  };

    background: rgba(0, 0, 0, 0.4);
  }
`;

export const CategoriesSection = styled.div`
  width: 100%;

  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;

  padding: 20px;
  margin: 10px 0;

  div {
    display: flex;
    align-items: center;

    input {
      padding: 10px 20px;

      max-width: 250px;
      width: 100%;
      height: 40px;

      background: rgba(0, 0, 0, 0.2);

      border: none;
      border-radius: 20px;

      font: 400 18px 'Roboto', sans-serif;
      color: #fff;

      transition: all 0.3s;

      &::placeholder {
        font: 300 16px 'Roboto', sans-serif;
        color: #fffb;
      }

      &:focus {
        background: rgba(0, 0, 0, 0.4);
      }
    }

    & > button {
      margin: 0 5px;
      padding: 10px;
    }
  }

  div + div {
    margin-top: 20px;
    flex-wrap: wrap;
  }
`;

export const CategoryTag = styled.small`
  display: flex;
  align-items: center;

  white-space: nowrap;

  font: 700 16px 'Roboto', sans-serif;

  background: #59c17c;
  padding: 5px;
  margin: 0 7px 7px 0;
  border-radius: 5px;

  button {
    background: none;
    padding: 0;
    margin: 0;
    margin-left: 5px;

    svg {
      transition: all 0.3s;
    }

    &:hover {
      background: none;

      svg {
        color: #db5461 !important;
      }
    }
  }
`;

export const Footer = styled(Header)`
  margin-top: 15px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ConfirmModal = styled.div`
  display: ${props => (props.open ? 'block' : 'none')};
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    transform: translate(-50%, -50%);

    background-color: rgba(0, 0, 0, 0.5);

    color: #fff;
    font: 700 16px 'Roboto', sans-serif;

    margin: auto;
    padding: 20px;

    border: none;
    border-radius: 20px;

    h2,
    h3 {
      margin-bottom: 10px;
    }

    span {
      display: flex;

      margin-top: 25px;
    }
  }
`;
